import React from 'react'

// Reactor
import useReactor from 'reactor/hooks/useReactor'
import usePlexUiTheme from 'reactor-vera/apps/ui/hooks/usePlexUiTheme'

import PlexUiDomain from './PlexUiDomain'


const PlexUiDomainRouter = ({
  zone,
  domain
}) => {
  const plexUiTheme = usePlexUiTheme()
  const DomainHandler = plexUiTheme?.components?.[domain.componentKey] || PlexUiDomain

  if (!DomainHandler) {
    console.warn('Domain handler not found for domain', domain, reactor.directory.reactorVera?.components)
    return null
  }

  return <DomainHandler zone={zone} domain={domain}/>
}

export default PlexUiDomainRouter